import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";

type ScanPeerIdProps = {
  visible: boolean;
  onScanned: (id: string) => void;
  onCancel: () => void;
};

export function ScanPeerId({ visible, onScanned, onCancel }: ScanPeerIdProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const qrInstanceRef = useRef<any>(null);

  useEffect(() => {
    let stopped = false;
    async function start() {
      if (!visible) return;
      const { Html5Qrcode } = await import("html5-qrcode");
      const containerId = "qr-reader-container";
      if (!containerRef.current) return;
      // ensure inner container exists
      let inner = containerRef.current.querySelector<HTMLDivElement>("#" + containerId);
      if (!inner) {
        inner = document.createElement("div");
        inner.id = containerId;
        containerRef.current.appendChild(inner);
      } else {
        inner.innerHTML = "";
      }
      const qr = new Html5Qrcode(containerId);
      qrInstanceRef.current = qr;
      try {
        await qr.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: 240 },
          (decodedText: string) => {
            if (stopped) return;
            stopped = true;
            // stop and clear then callback
            qr
              .stop()
              .catch(() => {})
              .finally(() => {
                qr.clear();
                onScanned(decodedText.trim());
              });
          },
          () => {
            // ignore scan failure
          }
        );
      } catch {
        // 启动失败，直接回退
        onCancel();
      }
    }
    start();
    return () => {
      stopped = true;
      const qr = qrInstanceRef.current;
      if (qr) {
        try {
          qr.stop().catch(() => {});
          qr.clear().catch(() => {});
        } catch {}
        qrInstanceRef.current = null;
      }
    };
  }, [visible, onScanned, onCancel]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className="bg-background rounded-lg shadow-lg w-full max-w-sm p-4 space-y-3">
        <div className="flex items-center justify-between">
          <div className="font-semibold">扫码录入 Peer ID</div>
          <Button variant="ghost" size="sm" onClick={onCancel}>
            关闭
          </Button>
        </div>
        <div ref={containerRef} className="rounded-md overflow-hidden">
          {/* inner reader container will mount here */}
        </div>
        <div className="text-xs text-muted-foreground">请将二维码置于取景框内自动识别</div>
      </div>
    </div>
  );
}


